import React from "react";
import "./PricingBoxs.css";

function PricingBoxs() {
  const starter_text =
    "Starter" +
    "\n" +
    "---------------" +
    "\n" +
    "Price: Free" +
    "\n" +
    "\n" +
    "- List of website improvements" +
    "\n" +
    "- Free quote" +
    "\n" +
    "\n" +
    "Additional Notes: ";

  const premium_text =
    "Premium" +
    "\n" +
    "---------------" +
    "\n" +
    "Price: 750$" +
    "\n" +
    "\n" +
    "- Full customized website" +
    "\n" +
    "- Up front custom designs to choose from" +
    "\n" +
    "- Unlimited revisions" +
    "\n" +
    "- Maintenance & support offered before and after product release" +
    "\n" +
    "\n" +
    "Additional Notes: ";

  function goToContactStarter() {
    document.getElementById("budget").value = starter_text;
    window.scrollTo(0, document.getElementById("contact").offsetTop);
    //localStorage.setItem("pre_set_text", starter_text);
  }
  function goToContactPremium() {
    document.getElementById("budget").value = premium_text;
    window.scrollTo(0, document.getElementById("contact").offsetTop);
    //localStorage.setItem("pre_set_text", premium_text);
  }

  return (
    <div className="price-box-container">
      <div className="free-box-container">
        <div className="box-content">
          <p className="free-header">STARTER</p>

          <p className="free-price">Free</p>
          <p className="free-desc">Full website review &amp; quote.</p>
          <br />
          <button
            onClick={goToContactStarter}
            className="clickToContact-starter"
          >
            Get Started For Free!
          </button>
          <ul className="feature-list">
            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">List of Website Improvements</p>
            </li>
            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">Free Quote</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="prem-box-container">
        <div className="box-content">
          <p className="prem-header">PREMIUM</p>

          <p className="prem-price">
            <span className="dol"></span>Custom
          </p>
          <p className="prem-desc">
            Custom tailored site to meet all your needs.
          </p>

          <button
            onClick={goToContactPremium}
            className="clickToContact-premium"
          >
            Let's Work!
          </button>

          <ul className="feature-list">
            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">100% Money Back Guarantee</p>
            </li>
            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">
                Completely Custom Website Tailored to Match Your Brand.
              </p>
            </li>
            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">Unlimited Revisions</p>
            </li>

            <li className="feature">
              <img
                alt=""
                src="https://img.icons8.com/material/24/f3f3f3/checkmark--v1.png"
              />
              <p className="feature-txt">
                Maintenance and Support Offered Before and After the Project is
                Launched.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PricingBoxs;
